export const checkDeletedField = (fieldId, field) => {
  if (fieldId) {
    if (!field.length) {
      return `${fieldId} *(deleted)`;
    }
    if (
      field.find(
        (property) =>
          property.name === fieldId ||
          property.id === fieldId ||
          property.value === fieldId
      )
    ) {
      return fieldId;
    }
    return `${fieldId} *(deleted)`;
  }
  return null;
};

export const isFieldExist = (fieldId, properties) => {
  if (fieldId) {
    if (!properties?.length) {
      return false;
    }
    if (
      properties.find(
        (property) =>
          property.name === fieldId ||
          property.id === fieldId ||
          property.value === fieldId
      )
    ) {
      return true;
    }
    return false;
  }
  return false;
};
export const checkMultipleDeletedField = (selectedStages, stages) => {
  if (selectedStages.length) {
    const selectedStagesArr = [];
    // eslint-disable-next-line no-plusplus
    for (let j = 0; j < selectedStages.length; j++) {
      if (stages === undefined) {
        selectedStagesArr.push(`${selectedStages[j]} *(deleted)`);
      } else if (
        stages.length &&
        stages.find((e) => e.id === selectedStages[j])
      ) {
        selectedStagesArr.push(selectedStages[j]);
      } else {
        selectedStagesArr.push(`${selectedStages[j]} *(deleted)`);
      }
    }
    return selectedStagesArr;
  }
  return [];
};

export const checkDeleteProperty = (propertyId, label) => {
  if (propertyId) {
    if (label === undefined) {
      return `${propertyId} *(deleted) = `;
    }
    return `${label} = `;
  }
  return null;
};

export const checkTextInputDefaultValue = (dValue, label) => {
  if (label.includes('*(deleted)')) {
    return '*(deleted)';
  }
  return dValue;
};
